<template>
  <el-container>
    <el-header>
      <el-row :gutter="20" justify="space-between" type="flex">
        <el-col :span="6">
          <div class="logo flex middle">
            <img src="~@/assets/common/loading.gif" />
            <img class="mini" src="~@/assets/common/logo_long.png" />
            <!-- <span>ICS管理系统</span> -->
          </div>
        </el-col>
        <el-col :span="12">
          <div class="menu">
            <div class="user-box">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  <img src="~@/assets/common/joyfulicon1.png" /> <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-switch-button" command="doLogout">退出</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

            </div>
          </div>
        </el-col>
      </el-row>
      
    </el-header>
    <el-container>
      <el-aside width="256px">
        <HomeMenu></HomeMenu>
      </el-aside>
      <el-container>
        <el-main>
          <router-view></router-view>
        </el-main>
        <el-footer>Copyright 2021©喜悦汇(ICS)-版权所有</el-footer>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import HomeMenu from './HomeMenu';

export default {
  name: 'Home',
  components: {
    HomeMenu
  },
  data(){
    
    return {
     
    }
  },
  mounted () {
    
  },
  methods: {
    handleCommand(command){
      if(command=='doLogout'){
        window.localStorage.removeItem("token");
        this.$nextTick(()=>{
          this.$router.push('/Login');
        });
      }
      
    }
  }
}
</script>

<style lang="less">
.el-header{
  background-color: #fff;
  box-shadow: 0 1px 2px rgb(150 150 150 / 30%);
  padding: 0 40px;
  position: relative;
  text-align: left;
  height: 60px;
  
  margin-bottom:40px;
  div.logo{
    padding-top:8px;
    cursor: pointer;
    span{margin-left:10px;color: #5e5e5e;font-size: 22px;}
    img{
      height:36px;vertical-align: bottom;
      &.mini{
        margin-left:10px; 
        padding-top:3px;
        padding-bottom:3px;
        height:30px; 
        border-bottom:2px solid #e6e6e6
      }
    } 
  }
  div.menu{
    text-align: right;
    padding-top:10px;
    .user-box{
      cursor: pointer;
      img{
        height:36px;
        vertical-align: text-bottom;
      }

    }
  }
  
}

.el-main{padding-top:10px}
.el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: transparent;
  color: #576b95;
}
.el-footer {
  line-height: 60px;
  text-align: right;
  color:#aaa;
}
  
</style>
